import CitiesIndex from "@/components/CitiesIndex";
import InteractiveMap from "@/components/InteractiveMap";
import Seo from "@/components/Seo";
import QuoteForm from "@/components/QuoteForm";
import EditorialMarquee from "@/components/EditorialMarquee";
import { motion } from "framer-motion";
import { IDS } from "@/lib/testIds";
import { useLang } from "@/lib/LangContext";

export default function AllCities() {
  const { cities: CITIES, lang } = useLang();
  return (
    <div data-testid={IDS.cities.indexRoot}>
      <Seo
        title="Security Guards by New Brunswick City | Maze Security"
        description="Find guard and mobile patrol options by New Brunswick community, including Moncton, Fredericton and Saint John. Confirm service availability locally."
        path="/cities"
      />
      <section className="pt-32 md:pt-40 pb-16 border-b border-border">
        <div className="mx-auto max-w-[1600px] px-6 md:px-12">
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-muted-foreground mb-6">
            [ {lang === "fr" ? "Couverture · Nouveau-Brunswick" : "Coverage · New Brunswick"} ]
          </div>
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
            className="font-serif font-light text-4xl md:text-7xl leading-[0.95] tracking-tight max-w-5xl"
          >
            {lang === "fr"
              ? <>Couverture de sécurité par communauté du <i className="text-primary">Nouveau-Brunswick</i></>
              : <>Security coverage by <i className="text-primary">New Brunswick community</i></>}
          </motion.h1>
          <p className="text-foreground/80 mt-8 max-w-2xl text-lg leading-relaxed">
            {lang === "fr"
              ? "Choisissez une ville pour consulter les options de service locales, les besoins d'accès et les moyens de demander un agent."
              : "Choose a city to review local service options, access needs and ways to request a guard."}
          </p>
        </div>
      </section>
      <InteractiveMap />
      <CitiesIndex />
      <EditorialMarquee />
      <QuoteForm />
    </div>
  );
}
